export const DISABLE_VALUE_TOOLTIP = 'Please, select a key first';
